var _rect, _text, _text2, _text3, _text4, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase4Fig1SixLayerContextStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Where a lesson gets encoded, and what each layer costs")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Six layers, chosen by how the rule needs to fire and what it costs to keep loaded")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 112,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "LAYER")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 792,
    y: 112,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "COST PER TURN")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 126,
    width: 720,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 156,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Global instructions"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 180,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Stable behavior policy that applies to every project"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 140,
    width: 240,
    height: 44,
    rx: 8,
    fill: "#F5F2E8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 912,
    y: 167,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "always loaded, pays a token tax"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 208,
    width: 720,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 238,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Global settings and hooks"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 262,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Mechanical enforcement: the harness runs it, so it cannot be forgotten"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 222,
    width: 240,
    height: 44,
    rx: 8,
    fill: "#F7FAF8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 912,
    y: 249,
    fontSize: 12.5,
    fill: "#16A34A",
    textAnchor: "middle",
    fontWeight: 600
  }, "zero, and it always fires"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 290,
    width: 720,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 320,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Project instructions"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 344,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Stable conventions only, pointing at the state files instead of restating them"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 304,
    width: 240,
    height: 44,
    rx: 8,
    fill: "#F5F2E8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 912,
    y: 331,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "always loaded, pays a token tax"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 372,
    width: 720,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 402,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "State files"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 426,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Current work, dated history, locked decisions, the system map"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 386,
    width: 240,
    height: 44,
    rx: 8,
    fill: "#FDFCF8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 912,
    y: 413,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "read at session start"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 454,
    width: 720,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 484,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The typed memory store"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 508,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "One fact per entry, with its why and how to apply, behind a one-line index"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 468,
    width: 240,
    height: 44,
    rx: 8,
    fill: "#FDFCF8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 912,
    y: 495,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "index loads, entries fetch on demand"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 536,
    width: 720,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 566,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Skills and commands"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 590,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Long procedure, loaded only when the matching task actually starts"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 550,
    width: 240,
    height: 44,
    rx: 8,
    fill: "#F7FAF8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 912,
    y: 577,
    fontSize: 12.5,
    fill: "#16A34A",
    textAnchor: "middle",
    fontWeight: 600
  }, "on demand only"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 118,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "end"
  }, "trimmed 223 lines to 132 with no behavior lost"), /*#__PURE__*/React.createElement("line", {
    x1: 752,
    y1: 124,
    x2: 752,
    y2: 140,
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase4Fig1SixLayerContextStack);
export default __webpack_public_path__ + "static/media/case4-fig1-six-layer-context-stack.6cec533d45921b2a6a825d206035bc7b.svg";
export { ForwardRef as ReactComponent };